import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import './CaseListItem.scss';

const CaseListItem = ({
  caseNumber,
  court,
  filingDate,
  name,
}) => (
  <div className="case-list-item">
    <div className="case-list-item__group">
      {name && (
        <div className="case-list-item__name">
          {name}
        </div>
      )}
      {court && (
        <div className="case-list-item__details">
          <div className="case-list-item__details-label">
            Court:
          </div>
          <div className="case-list-item__details-value">
            {court}
          </div>
        </div>
      )}
    </div>
    <div className="case-list-item__group case-list-item__group--align-right">
      {caseNumber && (
        <div className="case-list-item__details">
          <div className="case-list-item__details-label">
            Case number:
          </div>
          <div className="case-list-item__details-value">
            {caseNumber}
          </div>
        </div>
      )}
      {filingDate && (
        <div className="case-list-item__details case-list-item__details--with-margin">
          <div className="case-list-item__details-label">
            Filing date:
          </div>
          <div className="case-list-item__details-value">
            {moment(filingDate).format('L')}
          </div>
        </div>
      )}
    </div>
  </div>
);

CaseListItem.propTypes = {
  name: PropTypes.string,
  caseNumber: PropTypes.string,
  court: PropTypes.string,
  filingDate: PropTypes.string,
};

CaseListItem.defaultProps = {
  name: '',
  caseNumber: '',
  court: '',
  filingDate: '',
};

export default CaseListItem;



// WEBPACK FOOTER //
// ./src/routes/Cases/components/CaseListItem/CaseListItem.js